/** Pure helpers for EntityRef click behavior (D-DT10). */

export type EntityRefModifierEvent = {
  button?: number;
  metaKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
};

/**
 * True when the browser should open `fullPageTo` (new tab / modified click)
 * instead of invoking peek.
 */
export function entityRefShouldOpenFullPage(e: EntityRefModifierEvent): boolean {
  if (e.button === 1) return true;
  return Boolean(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
}
